import { toIsoDate } from '@/core/lib/germanDate'
import { getAt } from '@/core/lib/path'
import type { FieldId } from '@/core/lib/result'
import type { BewilligungForm } from '../lib/extractBewilligung'

const s = (v: unknown) => (v == null ? '' : String(v))

export type CoachingVoucherPatch = Partial<{
  inhalt_gruppen: string
  inhalt_einzel: string
  zeitl_umf_kategorie: string
  zeitl_umf_max_ue: number
}>

type AdoptTarget = {
  doc: 'avgs' | 'tb'
  path: FieldId
  transform?: (v: string) => string
  column?: 'inhalt_gruppen' | 'inhalt_einzel' | 'zeitl_umf_kategorie'
  intColumn?: 'zeitl_umf_max_ue'
}

const ADOPT_MAP: Partial<Record<FieldId, AdoptTarget>> = {
  'Maßnahme.Beginn der Maßnahme': { doc: 'tb', path: 'Maßnahme.Beginn der Teilnahme', transform: toIsoDate },
  'Maßnahme.Ende der Maßnahme': { doc: 'tb', path: 'Maßnahme.Ende der Teilnahme', transform: toIsoDate },
  'Maßnahme.Maßnahmeinhalt (Gruppenmaßnahme)': {
    doc: 'avgs',
    path: 'Maßnahme.Maßnahmeinhalt (Gruppenmaßnahme)',
    column: 'inhalt_gruppen',
  },
  'Maßnahme.Maßnahmeinhalt (Einzelmaßnahme)': {
    doc: 'avgs',
    path: 'Maßnahme.Maßnahmeinhalt (Einzelmaßnahme)',
    column: 'inhalt_einzel',
  },
  'Maßnahme.Zeitlicher Umfang (Kategorie)': {
    doc: 'avgs',
    path: 'Maßnahme.Zeitlicher Umfang (Kategorie)',
    column: 'zeitl_umf_kategorie',
  },
  'Maßnahme.Zeitlicher Umfang (max UE)': {
    doc: 'avgs',
    path: 'Maßnahme.Zeitlicher Umfang (max UE)',
    intColumn: 'zeitl_umf_max_ue',
  },
}

const NUMMER: FieldId = 'Maßnahme.Nummer der Maßnahme'
const TB_BEZEICHNUNG: FieldId = 'Maßnahme.Bezeichnung der Maßnahme'

export type Patch = { path: FieldId; value: string }
export type AdoptionPatches = { avgs: Patch[]; tb: Patch[]; coaching: CoachingVoucherPatch }

export function computeAdoptionPatches(
  extracted: BewilligungForm,
  adoptable: FieldId[],
  opts: { massnahmeSelection?: string } = {},
): AdoptionPatches {
  const avgs: Patch[] = []
  const tb: Patch[] = []
  const coaching: CoachingVoucherPatch = {}
  for (const field of adoptable) {
    if (field === NUMMER) {
      if (opts.massnahmeSelection) tb.push({ path: TB_BEZEICHNUNG, value: opts.massnahmeSelection })
      continue
    }
    const target = ADOPT_MAP[field]
    if (!target) continue
    const raw = s(getAt(extracted, field))
    const value = (target.transform ? target.transform(raw) : raw).trim()
    if (target.intColumn && !/^\d+$/.test(value)) continue
    ;(target.doc === 'avgs' ? avgs : tb).push({ path: target.path, value })
    if (target.column) coaching[target.column] = value
    if (target.intColumn) coaching[target.intColumn] = parseInt(value, 10)
  }
  return { avgs, tb, coaching }
}
